import axios from 'axios';

axios.defaults.timeout = 100000;
axios.defaults.baseURL = 'https://cms.wantdo.com/cms-admin/f/shopify/share';

/**
 * http request 拦截器
 */

axios.interceptors.request.use(
	(config) => {
		config.data = JSON.stringify(config.data);
		config.headers = {
			'Content-Type': 'application/json',
		};
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
)

/**
 * http response 拦截器
 */

axios.interceptors.response.use(
	(response) => {
		if (response.data.errCode === 2) {
			console.log('过期')
		}
		return response;
	},
	(error) => {
		console.log('请求出错', error);
	}
)

/**
 * 封装get方法
 * @param url 请求url
 * @param params 请求参数
 * @returns { Promise }
 */

export function get(url, params = {}) {
	return new Promise((resolve, reject) => {
		axios.get(url, {
				params: params
			}).then((response) => {
				// landing(url, params, response.data);
				resolve(response.data);
			})
			.catch((error) => {
				msag(error)
				console.log(error)
			})
	})
}

/**
 * 封装post方法
 * @param url 请求url
 * @param data 发送数据
 * @returns { Promise }
 */

export function post(url, data) {
	return new Promise((resolve, reject) => {
		axios.post(url, data)
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				msag(error)
				console.log(error)
			})
	})
}

export default function (fetch, url, param) {
	return new Promise((resolve, reject) => {
		switch (fetch) {
			case 'get':
				console.log("begin a get request,and url:", url);
				get(url, param)
				.then((response)=>{
					resolve(response);
				})
				.catch((error)=>{
					console.log("get request GET failed.", error);
					reject(error)
				});
				break;
			case 'post':
				console.log("begin a post request,and url:", url);
				post(url, param)
				.then((response) => {
					resolve(response)
				})
				.catch((error) => {
					console.log(error)
					reject(error)
				});
				break;
			default :
				break;

		}
	})
}

// 失败提示
function msag(err) {
	if (err && err.response) {
		switch (err.response.status) {
			case 400:
				console.log(err.response.data.error.details);
				break;
			case 401:
				console.log("未授权，请登录");
				break;

			case 403:
				console.log("拒绝访问");
				break;

			case 404:
				console.log("请求地址出错");
				break;

			case 408:
				console.log("请求超时");
				break;

			case 500:
				console.log("服务器内部错误");
				break;

			case 501:
				console.log("服务未实现");
				break;

			case 502:
				console.log("网关错误");
				break;

			case 503:
				console.log("服务不可用");
				break;

			case 504:
				console.log("网关超时");
				break;

			case 505:
				console.log("HTTP版本不受支持");
				break;
			default:
		}
	}
}